import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from './context/AuthContext.js';
import { getApiBase } from './backendProbe.js';

export default function FacebookCallback() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [isProcessing, setIsProcessing] = useState(true);

  useEffect(() => {
    // Prevent browser from showing "unsaved changes" warning
    window.history.replaceState(null, '', window.location.pathname);
    
    // Extract code or error from URL params
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const error = urlParams.get('error');
    const errorReason = urlParams.get('error_reason');
    const errorDescription = urlParams.get('error_description');

    if (error) {
      console.error('Facebook OAuth error:', error, errorReason, errorDescription);
      let errorMessage = errorDescription || errorReason || error;
      
      // Provide helpful error messages for common issues
      if (error === 'invalid_client_id' || errorDescription?.includes('Invalid App ID')) {
        errorMessage = 'Facebook login is not properly configured. Please contact support or use another login method (Google, Microsoft, or Apple).';
      } else if (error === 'access_denied') {
        errorMessage = 'You cancelled the Facebook login. Please try again if you want to continue.';
      }
      
      setIsProcessing(false);
      setTimeout(() => {
        alert(`Facebook login failed: ${errorMessage}`);
        navigate('/login', { replace: true });
      }, 100);
      return;
    }

    if (code) {
      // Exchange code for access token via backend
      const base = getApiBase();
      const endpoint = base ? `${base}/auth/facebook` : '/auth/facebook';
      axios.post(endpoint, { code })
        .then((response) => {
          login(response.data.token, response.data.user);
          setIsProcessing(false);
          navigate('/chatbot', { replace: true });
        })
        .catch((err) => {
          console.error('Facebook login failed', err);
          setIsProcessing(false);
          const errorMsg = err.response?.status === 403 && err.response?.data?.code === 'INVITE_ONLY'
            ? (err.response.data.message || "This app is invite-only. You don't have access.")
            : (err.response?.data?.message || 'Facebook login failed. Please try again.');
          setTimeout(() => {
            alert(errorMsg);
            navigate('/login', { replace: true });
          }, 100);
        });
    } else {
      console.error('No Facebook code found in callback');
      setIsProcessing(false);
      setTimeout(() => {
        navigate('/login', { replace: true });
      }, 100);
    }
  }, [navigate, login]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontSize: '18px'
    }}>
      {isProcessing ? 'Processing Facebook login...' : 'Redirecting...'}
    </div>
  );
}

